import React, { FC } from "react";
import { Avatar, Box } from "@mui/material";
import { emptyStyle, Image } from "./GvAvatarCustom.style";

interface IAvatarCustomProps {
  image?: string;
  name?: string;
  width: number;
  height: number;
  className?: string
  customName?: string
}

const GvAvatarCustom: FC<IAvatarCustomProps> = ({ image, name, width, height, className, customName }) => {
  return <Box style={{ display: "inline-block" }} className={className}>
    {
      image ?
        <Avatar sx={{ width, height }}>
          <Image src={image} alt={name} />
        </Avatar> :
        <Box sx={emptyStyle} style={{ width, height }} className="capitalize">
          {customName ? customName : name?.charAt(0)}
        </Box>
    }
  </Box>;
};

export default GvAvatarCustom;
